import { CatalogOverplot } from '@/modules/CatalogOverplotModule/CatalogOverplot';
import { CasModule } from '@/modules/ssp_database/CasModule';
import { cas, ICasJob } from '@/modules/ssp_database/CasModule/cas';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { store } from '@/store';

@Component
export default class JobListWindow extends Vue {
  @Prop({ required: true })
  module!: CasModule

  page = 1
  // tslint:disable-next-line:variable-name
  num_pages = 1
  jobs: ICasJob[] = []

  private async reload() {
    await store.asyncProgress('Refreshing', async () => {
      const { jobs, num_pages } = await cas.jobIndex(this.page)
      this.jobs = jobs
      this.num_pages = num_pages;
      (this.$refs.scroll as HTMLDivElement).scrollTo(0, 0)
    })
  }

  @Watch('page')
  onPageChange() {
    this.reload()
  }

  mounted() {
    this.$watch(() => this.module.showJobList, (show) => {
      if (show) {
        this.reload()
      }
    }, { immediate: true })
    this.module.$on('refresh-cas-job-list', () => this.reload())
  }

  async load(job: ICasJob) {
    await store.asyncProgress('Loading Remote Catalog', async () => {
      const ab = await cas.downloadJob(job)
      const co = await CatalogOverplot.fromCsvArrayBuffer(job.name, ab)
      store.currentFrame.modules.catalogOverPlot.cos.push(co)
      store.modules.catalogOverPlot.showList = true
    })
  }

  async remove(job: ICasJob) {
    await cas.deleteJob(job)
    this.reload()
  }

  async cancel(job: ICasJob) {
    await cas.cancelJob(job)
    this.reload()
  }

  available(job: ICasJob) {
    return job.status === 'done' && (job.out_format === 'csv' || job.out_format === 'csv.gz')
  }

  prettyBytes(filesize: number) {
    const readableFilesize = require('filesize')
    return readableFilesize(filesize)
  }
}
